import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledTextField } from 'components/shared';
import CLASelect from 'components/shared/CLASelect/CLASelect';
import {
  GridContainer,
  GridCompact12,
  GridCompact6
} from 'components/shared/Grid/Grid.components';

const BaseSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common');

  return (
    <GridContainer>
      <GridCompact12>
        <CLASelect />
      </GridCompact12>
      <GridCompact6>
        <ControlledTextField
          control={control}
          variant="outlined"
          label={t('salaryScales.grid.scale')}
          name="scale"
        />
      </GridCompact6>
      <GridCompact6>
        <ControlledTextField
          type="number"
          control={control}
          variant="outlined"
          label={t('salaryScales.grid.seniority')}
          name="seniority"
        />
      </GridCompact6>
      <GridCompact6>
        <ControlledTextField
          type="number"
          control={control}
          variant="outlined"
          label={t('salaryScales.grid.salaryNr')}
          name="salaryNr"
        />
      </GridCompact6>
      <GridCompact6>
        <ControlledTextField
          type="number"
          control={control}
          variant="outlined"
          label={t('salaryScales.grid.periodSalary')}
          name="periodSalary"
        />
      </GridCompact6>
    </GridContainer>
  );
};

export default BaseSection;
